import React, { useContext, useEffect, useState } from "react";
import { Link, Outlet } from "react-router-dom";

import styles from "./layout.module.scss";

import { Cast, ChartSpline, NotebookPen, Send, ShieldCheck } from "lucide-react";
import { MainContext } from "../../context/MainContext";

function Layout() {
  const { setSelectedMarker, user } = useContext(MainContext);

  const handleCloseModal = () => {
    setSelectedMarker(null);
  };

  return (
    <div className={styles.container}>
      <Outlet />
      <footer className={styles.footer}>
        <Link className={styles.footer__button} onClick={() => handleCloseModal()} to="/">
          <Cast color="#41f500" />
        </Link>
        <Link className={styles.footer__button} onClick={() => handleCloseModal()} to="statistics">
          <ChartSpline color="#41f500" />
        </Link>
        <Link className={styles.footer__button} onClick={() => handleCloseModal()} to="list">
          <NotebookPen color="#41f500" />
        </Link>
        <Link className={styles.footer__button} onClick={() => handleCloseModal()} to="map">
          <Send color="#41f500" />
        </Link>

        {user?.role === "admin" && (
          <Link className={styles.footer__button} onClick={() => handleCloseModal()} to="admin">
            <ShieldCheck color="#41f500" />
          </Link>
        )}
      </footer>
    </div>
  );
}

export default Layout;

// import React, { useContext, useEffect, useState } from "react";
// import { Outlet, Link } from "react-router-dom";
// import { Cast, ChartSpline, NotebookPen, Send, ShieldCheck } from "lucide-react";
// import { MainContext } from "./../../context/MainContext";

// import Mains from "./../../pages/Main";

// import styles from "./layout.module.scss";

// const Layout = () => {
//   const { setSelectedMarker, user } = useContext(MainContext);

//   const handleCloseModal = () => {
//     setSelectedMarker(null);
//   };
//   return (
//     <div className={styles.container}>
//       <div className={styles.portrait}>
//         <main className={styles.content}>
//           <Outlet />
//         </main>

//         <footer className={styles.footer}>
//           <Link className={styles.footer__button} onClick={handleCloseModal} to="/">
//             <Cast color="#41f500" />
//           </Link>

//           <Link className={styles.footer__button} onClick={handleCloseModal} to="statistics">
//             <ChartSpline color="#41f500" />
//           </Link>

//           <Link className={styles.footer__button} onClick={handleCloseModal} to="list">
//             <NotebookPen color="#41f500" />
//           </Link>

//           <Link className={styles.footer__button} onClick={handleCloseModal} to="map">
//             <Send color="#41f500" />
//           </Link>

//           {user?.role === "admin" && (
//             <Link className={styles.footer__button} onClick={handleCloseModal} to="admin">
//               <ShieldCheck color="#41f500" />
//             </Link>
//           )}
//         </footer>
//       </div>

//       {/* =========================
//           ГОРИЗОНТАЛЬНЫЙ РЕЖИМ
//           ========================= */}

//       <div className={styles.landscape}>
//         <div className={styles.landscape__content}>
//           <Outlet />
//         </div>

//         <div className={styles.landscape__map}>
//           <Mains />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Layout;
